import template from './textFormElement.html';
import controller from './textFormElement.controller';
import './textFormElement.scss';

let textFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '=',
    validationError: '<'
  },
  template,
  controller
};

export default textFormElementComponent;
